import { CacheManager } from '@descomplica/caching-browser';
export const CACHE_OPTIONS_METADATA = 'cacheOptionsMetadata';
export const injectCache = (cacheOptions) => (target, memberName) => {
    target[memberName] = CacheManager.getCache(cacheOptions.type, cacheOptions.namespace);
    Reflect.defineMetadata(CACHE_OPTIONS_METADATA, Object.assign(Object.assign({}, cacheOptions), { memberName }), target.constructor);
    return target;
};
